import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { Link as commonLink } from 'assets/Common/Link.style';

export const Link = styled(RouterLink)`
  ${commonLink}
  font-weight: 700;
`;
